import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Search from './components/Search';
import reportWebVitals from './reportWebVitals';

ReactDOM.render(
    <Search />,
    document.getElementById('root')
);

reportWebVitals();
